import API from 'shared/constants/api';
import { JOURNAL } from '../constants/actionTypes';
const defaultVideoFilters = {
  make: null,
  model: null,
  generation: null,
  topic: null,
};

export const setJournalNews = news => ({
  type: JOURNAL.SET_NEWS,
  payload: news,
});

export const setVideoTopics = topics => ({
  type: JOURNAL.SET_VIDEO_TOPICS,
  payload: topics,
});

export const setOrderingField = selectedHeadFilter => ({
  type: JOURNAL.SET_VIDEO_HEAD_FILTER,
  payload: selectedHeadFilter,
});

export const setVideoFilters = (filters = defaultVideoFilters) => ({
  type: JOURNAL.SET_VIDEO_FILTERS,
  payload: filters,
});

export const setSelectedVideoParams = params => ({
  type: JOURNAL.SET_SELECTED_VIDEO_PARAMS,
  payload: params,
});

export const setSelectedVideoData = data => ({
  type: JOURNAL.SET_SELECTED_VIDEO_DATA,
  payload: data,
});

export const videoCounter = postId => (dispatch, getState, { fetch }) => {
  const userId = getState().user.user.id;
  const counterRequest = {
    event: 'view',
    fingerprint: getState().globals.fingerprint,
    object_id: postId,
    object_type: 'post',
  };

  if (userId) counterRequest.user_id = userId;

  fetch(API.JOURNAL.SET_STATS(), {
    method: 'POST',
    body: JSON.stringify(counterRequest),
  }).then(packages => {
    if (packages.status === 200) {
      return packages.json();
    }
    return null;
  });
  return Promise.resolve();
};

const getVideoContent = (fetch, dispatch, videoId) =>
  fetch(API.JOURNAL.ITEM(videoId))
    .then(r => r.json())
    .then(results => {
      const content = Array.isArray(results) && results[0].content;
      dispatch(setSelectedVideoData(content));
      dispatch(videoCounter(results[0].id));
    });

export const getVideoById = (videoParams = null) => (dispatch, getState, { fetch }) => {
  dispatch(setSelectedVideoParams(videoParams));

  if (videoParams) {
    getVideoContent(fetch, dispatch, videoParams.id);
  } else {
    dispatch(setSelectedVideoData(videoParams));
    dispatch(setSelectedVideoParams(videoParams));
  }
  return Promise.resolve();
};



// WEBPACK FOOTER //
// ./src/shared/actions/journal.js